:host([light]) {
    & .issues_d,
    & .issues_e {
        fill: #bbdefb;
    }
    & .issues_f {
        fill: #fff;
    }
    & .issues_f,
    & .issues_g,
    & .issues_h,
    & .issues_e {
        fill-rule: evenodd;
    }
    & .issues_g {
        fill: url(#issues_c);
    }
    & .issues_i {
        fill: none;
        stroke: #1a4e85;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 8px;
    }
    & .issues_h {
        fill: url(#issues_b);
    }
    & .issues_j {
        fill: #1a4e85;
    }
}
:host([dark]) {
    & .issues_d,
    & .issues_e {
        fill: #09264a;
    }
    & .issues_e,
    & .issues_f,
    & .issues_g,
    & .issues_h {
        fill-rule: evenodd;
    }
    & .issues_f {
        fill: url(#issues_c);
    }
    & .issues_i {
        fill: none;
        stroke: #fff;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 8px;
    }
    & .issues_g {
        fill: url(#issues_b);
    }
    & .issues_h {
        fill: #ced4db;
    }
}
